import React from 'react';
import SectionWrapper from './SectionWrapper';
import { useAppData } from '../../context/AppContext';
import InFocusItem from './InFocusItem';
import * as FiIcons from 'react-icons/fi';
import { v4 as uuidv4 } from 'uuid';
import { format } from 'date-fns';
import { exportInFocusOnlyPDF } from '../../utils/pdf';

export default function InFocus() {
  const { watchlists, currentDaily, updateCurrentDaily, currentDate } = useAppData();
  
  const items = Array.isArray(currentDaily?.inFocusItems) ? currentDaily.inFocusItems : [];

  const handleDownload = () => {
    const dateStr = format(currentDate, 'EEEE, dd MMMM yyyy');
    exportInFocusOnlyPDF(dateStr, items, watchlists);
  };

  const addItem = () => {
    const newItem = {
      id: uuidv4(),
      watchlistId: '',
      instrumentId: '',
      todayPlan: '',
      tradeLog: [],
      imageBase64: '', // Standardized key
      chartUrl: '',
      chartCaption: '',
      carryOver: true
    };
    
    updateCurrentDaily({
      ...currentDaily,
      inFocusItems: [...items, newItem]
    });
  };

  const updateItem = (id, updates) => {
    const newItems = items.map(item => 
      item.id === id ? { ...item, ...updates } : item
    );
    updateCurrentDaily({ ...currentDaily, inFocusItems: newItems });
  };

  const removeItem = (id) => {
    if (!confirm('Remove this instrument from focus?')) return;
    const newItems = items.filter(item => item.id !== id);
    updateCurrentDaily({ ...currentDaily, inFocusItems: newItems });
  };

  return (
    <SectionWrapper title="In Focus" onDownload={handleDownload}>
      <div className="space-y-8">
        {items.map((item, index) => (
          <div key={item.id} className="relative">
            {index > 0 && <div className="border-t border-app-border/50 my-12" />}
            <div className="flex justify-end mb-4">
              <button 
                onClick={() => removeItem(item.id)}
                className="text-app-muted hover:text-app-red flex items-center gap-2 text-[10px] font-black uppercase tracking-widest transition-all bg-app-surface px-3 py-1.5 rounded-lg border border-app-border hover:border-app-red/30 shadow-sm"
              >
                <FiIcons.FiTrash2 size={12} /> Remove From Today
              </button>
            </div>
            <InFocusItem 
              item={item} 
              watchlists={watchlists} 
              onUpdate={(updates) => updateItem(item.id, updates)} 
            />
          </div>
        ))}

        <button 
          onClick={addItem}
          className="w-full py-10 border-2 border-dashed border-app-border rounded-xl text-app-muted hover:border-app-accent hover:text-app-accent transition-all flex flex-col items-center justify-center gap-3 group bg-app-surface/30 hover:bg-app-surface/50"
        >
          <div className="w-14 h-14 rounded-full bg-app-bg border border-app-border flex items-center justify-center group-hover:bg-app-accent group-hover:text-black transition-all shadow-xl">
            <FiIcons.FiPlus size={28} />
          </div>
          <span className="font-black uppercase text-xs tracking-[0.4em] mt-2">Add Instrument to Focus</span>
        </button>
      </div>
    </SectionWrapper>
  );
}